module.exports = __webpack_public_path__ + "static/homebg-c467541b71397735f0239c129af137d7.jpg";